import { useState } from 'react';
import {
  CONCESSION_STATUS_NOT_STARTED,
  CONCESSION_STATUS_ACTIVE,
  CONCESSION_STATUS_ENDING_SOON,
  CONCESSION_STATUS_EXPIRED,
} from 'common/concessionConstants';

import {
  getConcessionEndMoment,
  getConcessionStartMoment,
  getConcessionStatus,
} from 'common/concessionHelpers';

import { SR_API_ACTION_CONCESSIONS_CREATE, SR_API_ACTION_CONCESSIONS_END } from 'api/actionTypes';

import ConcessionActions from 'client/actions/Concession';

import useDispatch from 'client/hooks/useDispatch';
import postWithState from 'client/actions/postWithState';

const useConcessionsProController = ({ concession }) => {
  const [isCreatingConcession, setIsCreatingConcession] = useState(false);

  const dispatch = useDispatch();

  const _onEndConcessionSubmit = () => {
    return dispatch(postWithState, {
      action: SR_API_ACTION_CONCESSIONS_END,
      payload: {
        concessionId: concession.id,
      },
    }).then(() => {
      return dispatch(ConcessionActions.getByListingId, {
        listingId: concession.listingId,
        forceReload: true,
      });
    });
  };

  const getConcessionStatusToUISettingsMapping = () => {
    const concessionStatus = concession ? getConcessionStatus({ concession }) : null;

    const concessionSubtext = concession
      ? `Valid ${getConcessionStartMoment({ concession }).format('MMM Do')} -
         ${getConcessionEndMoment({ concession }).format('MMM Do')}`
      : '';

    switch (concessionStatus) {
      case CONCESSION_STATUS_NOT_STARTED:
        return {
          color: 'grey',
          text: 'Rent Concession Not Started',
          endConcessionCtaActive: false,
          startConcessionCtaActive: true,
          subtext: concessionSubtext,
        };
      case CONCESSION_STATUS_ACTIVE:
        return {
          color: 'green',
          text: 'Active Rent Concession',
          endConcessionCtaActive: true,
          startConcessionCtaActive: false,
          subtext: concessionSubtext,
        };
      case CONCESSION_STATUS_ENDING_SOON:
        return {
          color: 'orange300',
          text: 'Rent Concession Ends Soon',
          endConcessionCtaActive: true,
          startConcessionCtaActive: false,
          subtext: concessionSubtext,
        };
      case CONCESSION_STATUS_EXPIRED:
        return {
          color: 'red',
          text: 'Inactive Rent Concession',
          endConcessionCtaActive: false,
          startConcessionCtaActive: true,
          subtext: concessionSubtext,
        };
      default:
        return {
          color: 'green',
          text: '',
          endConcessionCtaActive: false,
          startConcessionCtaActive: false,
          subtext: concessionSubtext,
        };
    }
  };

  const _handleConcessionSubmit = ({ listingId, endDate, amount, scheduleType }) => {
    return dispatch(postWithState, {
      action: SR_API_ACTION_CONCESSIONS_CREATE,
      payload: {
        listingId,
        endDate,
        amount,
        scheduleType,
        advertiseNER: false,
      },
    }).then(() => {
      setIsCreatingConcession(false);
      return dispatch(ConcessionActions.getByListingId, {
        listingId,
        forceReload: true,
      });
    });
  };

  return {
    ...getConcessionStatusToUISettingsMapping(),
    onEndConcessionSubmit: _onEndConcessionSubmit,
    onCancelConcessionCreation: () => setIsCreatingConcession(false),
    onStartConcessionCreation: () => setIsCreatingConcession(true),
    onCreateConcessionSubmit: _handleConcessionSubmit,
    hasActiveConcession: !!concession,
    isCreatingConcession,
  };
};

export default useConcessionsProController;
